import React from "react";
import {CardContent, CardHeader, Button} from "@mui/material";
import {useState} from "react";
import {useDispatch} from "react-redux";
import {deleteThemes} from "../../Redux/Action";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import {setModal} from "../../../../Common/App";
import {DialogCard} from "../../../../../Components/Cards/DialogCard";
import {Loader} from "../../../../../Components";

export const DeleteThemeModal = ({theme, onClose}) => {

    const dispatch = useDispatch();
    const [, setErrors] = useState({});
    const [, setMessage] = useState("");
    const [, setStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        setIsLoading(true);
        await deleteThemes({dispatch, filters: {id: theme.id}}).then((res) => {
            if(res.success) {
                dispatch(setModal({component:null, open:false}));
                if (onClose) onClose();
            }
            setIsLoading(false);
            setErrors(res.errors);
            setMessage(res.message);
            setStatus(res.status);
        });
    };

    return(
        <DialogCard>
            <CardHeader
                title={"Delete Theme"}
                avatar={<Loader isLoading={isLoading} type={"linear"}/>}
            />
            <CardContent sx={{ p: 2, pt:2 }}>
                <DialogContentText>
                    Are you sure you want to delete '{theme?.name}'? This action cannot be undone.
                </DialogContentText>
            </CardContent>
            <DialogActions sx={{ mb: 2, mr: 2 }}>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color={'error'} onClick={ handleSubmit }>Delete</Button>
            </DialogActions>
        </DialogCard>
    )
}
